import { isIframe } from 'iframe-support'
import { getFlowType } from './url-utils'
import store from '../stores/configureStore'
import { post } from '../../calculator/lib/xhr'
import logger from 'loglevel'
import { getSessionDataPayload } from 'transfer/utils/session'
import { ENV_TYPE } from '../../../../lib/constants'
import { amountIsZero } from '../../lib/amountUtils'

/*
 * @param {String} flowType - payment type
 * @returns {String} PURCHASE for Good and Services payment type,
  otherwise, returns PERSONAL. The function was created to satisfy SQ Cognitive Complexity limits
*/
export function getFeature(flowType) {
  return flowType === 'buy' ? 'PURCHASE' : 'PERSONAL'
}

export function handleInterstitialCipFlow(param) {
  const entryPoint = 'P2P',
    amount = store.getState().amount.amount,
    token = store.getState().recipient.token,
    networkId = store.getState().recipient.networkId,
    currencyCode = store.getState().amount.currencyCode,
    flowIntent = store.getState().server.flowIntent
  let flowType = getFlowType(),
    feature = getFeature(flowType),
    recipient = store.getState().recipient.recipient,
    payerId = store.getState().recipient.payerId,
    displayName = store.getState().recipient.displayName,
    thumbnailUrl = store.getState().recipient.thumbnailUrl,
    subFlow = 'send',
    externalUrl =
      getFlowType() === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl,
    env = store.getState().server.env

  if (typeof param === 'object') {
    flowType = param.flowType
    recipient = param.email
    thumbnailUrl = param.thumbnailUrl
    displayName = param.fullName
    payerId = param.payerId
    feature = getFeature(flowType)
    externalUrl =
      flowType === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl
  }
  if (param === 'send' || param === 'buy') {
    flowType = param
    if (getFlowType() === 'payRequest') {
      env = ENV_TYPE.PAY_REQUEST
      subFlow = 'pay_from_request'
    }
    feature = getFeature(flowType)
    externalUrl =
      param === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl
  }
  const homeinfoPayLoad = {
    flowType,
    entryPoint,
    feature,
    token,
    recipient,
    env,
    payerId,
    networkId,
    displayName,
    thumbnailUrl,
    externalUrl,
    subFlow,
    flowIntent,
    ...(!amountIsZero(amount) && {
      amount,
      currencyCode,
    }),
    ...getSessionDataPayload(),
  }
  const homeinfoFlowUrl = '/myaccount/transfer/flow/fi/aucip'
  const mainWindow = isIframe() ? window.top : window
  post(homeinfoFlowUrl, homeinfoPayLoad)
    .then(response => {
      const { redirectURL = {} } = response
      mainWindow.location.assign(redirectURL)
    })
    .catch(err => {
      logger.error(err)
    })
}
